let activeFormat = 'DD/MM/YYYY';

export function setWorkspaceDateFormat(format) {
  if (format === 'MM/DD/YYYY' || format === 'YYYY-MM-DD' || format === 'DD/MM/YYYY') {
    activeFormat = format;
  }
}

export function formatWorkspaceDate(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  if (activeFormat === 'MM/DD/YYYY') return `${month}/${day}/${year}`;
  if (activeFormat === 'YYYY-MM-DD') return `${year}-${month}-${day}`;
  return `${day}/${month}/${year}`;
}
